import classNames from "classnames";
import { LeaderInfo } from "../types/dashboard.types";
import {LongNumberFormat} from "./shared/Formats";

type BoxStatsProps = {
	children?: React.ReactNode;
	icon?: React.ReactNode;
	styles?: string;
	title: string;
	stats: { country: string; count: number }[];
	leadersInfo?: LeaderInfo[];
};

export const CountryLeaderListView = ({
	title,
	stats,
	icon,
	styles,
	leadersInfo = [],
}: BoxStatsProps) => {
	let leaderStats = leadersInfo.slice().sort((a, b) => {
		return b.totalAmount - a.totalAmount;
	});
	const totalRaisedAmount = leaderStats.reduce((sum, leader) => sum + (leader.totalAmount || 0), 0);

	return (
		<div className="h-full w-full flex flex-col gap-4">
			<div className="flex items-start justify-between gap-4">
				<div className="flex items-center gap-3 min-w-0">
					{icon ? (
						<div
							className={classNames(
								"rounded-xl h-11 w-11 flex items-center justify-center border border-white/60 dark:border-white/10 shrink-0",
								styles,
							)}
						>
							{icon}
						</div>
					) : null}
					<div>
						<p className="text-sm md:text-base font-medium tracking-wide text-gray-600 dark:text-gray-300">{title}</p>
						<h3 className="text-xl md:text-2xl font-semibold tracking-tight text-gray-900 dark:text-gray-100">Global leaderboard</h3>
					</div>
				</div>

				<div className="flex justify-end">
					<div className="rounded-xl bg-white/50 dark:bg-slate-800/75 border border-white/60 dark:border-white/10 px-4 py-2 text-center">
						<p className="text-[10px] uppercase tracking-[0.18em] text-gray-500 dark:text-gray-400">Total raised</p>
						<p className="mt-1 text-lg font-semibold text-gray-900 dark:text-gray-100">${LongNumberFormat(totalRaisedAmount)}</p>
					</div>
				</div>
			</div>

			<div className="flex-1 min-h-0 w-full mx-auto bg-white/45 dark:bg-slate-800/55 border border-white/60 dark:border-white/10 shadow-sm rounded-xl overflow-hidden">
					<table className="w-full table-auto border-collapse">
						<thead className="bg-primary-50/85 dark:bg-slate-700/80">
							<tr>
								<th className="w-16 px-4 py-3 text-left text-xs md:text-sm uppercase tracking-[0.16em] font-semibold text-gray-700 dark:text-gray-200">
									Rank
								</th>
								<th className="px-4 py-3 text-left text-xs md:text-sm uppercase tracking-[0.16em] font-semibold text-gray-700 dark:text-gray-200">
									Leader
								</th>
								<th className="w-40 px-4 py-3 text-right text-xs md:text-sm uppercase tracking-[0.16em] font-semibold text-gray-700 dark:text-gray-200">
									Raised
								</th>
							</tr>
						</thead>
						<tbody>
							{(Array.isArray(leaderStats) ? leaderStats : []).map(
								(stat, index) => (
									<tr
										key={index}
										className={`${
											index % 2 === 0 ? "bg-white/70 dark:bg-slate-900/55" : "bg-white/95 dark:bg-slate-900/70"
										} hover:bg-primary-50/70 dark:hover:bg-slate-700/60 transition-colors border-t border-gray-200/70 dark:border-white/10`}
									>
										<td className="px-4 py-3 text-sm font-semibold text-gray-700 dark:text-gray-200">
											<span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary-50 dark:bg-slate-700 text-gray-800 dark:text-gray-100">#{index + 1}</span>
										</td>
										<td className="px-4 py-3 text-sm font-medium text-gray-700 dark:text-gray-200 align-middle">
											{stat.userName}
										</td>
										<td className="px-4 py-3 text-sm font-semibold text-right text-gray-800 dark:text-gray-100 align-middle">
											${LongNumberFormat(stat.totalAmount)}
										</td>
									</tr>
								),
							)}
						</tbody>
					</table>
				</div>
		</div>
	);
};
